import './App.css';
import MetaConnection from './Connections/MetaConnection.js'
import Minter from './Minter.js'
import { HelmetProvider } from 'react-helmet-async';
import { IconContext } from "react-icons";
import { FaDiscord, FaTwitter} from 'react-icons/fa';

function MainApp() {
  return (

    <div className="App">
      <HelmetProvider>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@700&family=Ubuntu:wght@500&display=swap" rel="stylesheet"></link>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
      </HelmetProvider>

      <div className="Header">
        <div className='Icons'>
          <a href="https://discord.com/invite/MHGYpy5Ge6" className='discordIcon'>
              <IconContext.Provider value={{ className: 'react-icons' }} >
                  <FaDiscord size={42}/>
              </IconContext.Provider>
          </a>
          <a href="https://twitter.com/RandomHenryNFT" className='twitterIcon'>
              <IconContext.Provider value={{ className: 'react-icons' }} >
                  <FaTwitter size={42}/>
              </IconContext.Provider>
          </a>
          <a href="https://opensea.io/collection/random-henry" className='openseaIcon'>
            <img alt="Opensea link" id="openseaIcon"></img>
          </a>
        </div>
        
        <MetaConnection></MetaConnection>
      </div>
      <div className='Homepage'>
        <img alt="RH title" id="title"></img>
        <Minter></Minter>
      </div>
      <div className='Content'>
        <div id="leftBG">
          <h1 id="theProject">The PROJECT</h1>
          <p className="Big">Random Henry is a collection of 1,000 randomly generated NFTs, with 100+ different traits.</p>
          <p className="Big">📌 Every Henrys will be launched on the Polygon blockchain (means very few gas fees).</p>
          <div className='Roadmap'>
            <h3 id="Roadmap">ROADMAP</h3>
            <p className="Big">🎁 Giveaways for Henry owners up to 25% of the earnings generated by royalties on Opensea.</p>
            <p className="Big">🚀 Development of a 2nd larger collection, for which holders of Random Henry will have a prime access (WL spots, Free mints).
            We will give more details about the new collection and designs soon.</p>
            <p className="Big">After selling 500 Henrys:
            Donation to a charity chosen by the community.</p>
          </div>
          
        </div>
        <div id="rightBG">
          <img alt="RH title" id="traits"></img>

        </div>
      </div>
      
      
    </div>
  );
}

export default MainApp;